import { Driver } from "../../types/driver.types";

export interface DriverFormProps {
  visible: boolean;
  onHide: () => void;
  onSave: (driver: Partial<Driver>) => Promise<{ success: boolean; error?: string }>;
  driver: Driver | null;
  isTrial: boolean;
}

export const civilityOptions = [
  { label: "M.", value: "M." },
  { label: "Mme", value: "Mme" },
  { label: "Mlle", value: "Mlle" },
];

export const drivingLicenseTypeOptions = [
  { label: "VL", value: "VL", icon: "ph-bold ph-car" },
  { label: "PL", value: "PL", icon: "ph-bold ph-truck" },
  { label: "SPL", value: "SPL", icon: "ph-bold ph-truck-trailer" },
];

export const DUMMY_DRIVER: Omit<Driver, "_id" | "password"> = {
  drivingLicenseNumber: Math.floor(10000000 + Math.random() * 90000000),
  drivingLicenseType: "VL",
  name: "John",
  lastName: "Doe",
  email: `dalidaliovic+${Math.floor(Math.random() * 10000)}@gmail.com`,
  phone: "+33123456789",
  civility: "M.",
  birthDate: new Date(),
  creationDate: new Date(),
  manuallyActive: true,
  transporter: "66dbb850ec90de52657c15ec",
  selectedChapters: [], // Initialize with empty array
};

export const commonStyles = {
  inputClassName: "w-full p-inputtext-md rounded-lg overflow-clip py-3 font-sans ",
  labelClassName: "block text-md font-medium text-gray-700 mb-1 ",
  errorClassName: "text-red-500 text-sm mt-1 ",
};
